"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logEvent = logEvent;
exports.logImpression = logImpression;
exports.logSearchTermImpression = logSearchTermImpression;
exports.logSignalEvent = logSignalEvent;
var _UrlHelper = require("./UrlHelper");
function logEvent({
  eid,
  type,
  properties
}) {
  window._expDataLayer = window._expDataLayer || [];
  window._expDataLayer.push({
    schema: 'add_event',
    version: 'v1',
    data: {
      eid,
      type,
      properties
    }
  });
}
function logImpression(eid) {
  window._expDataLayer = window._expDataLayer || [];
  window._expDataLayer.push({
    schema: 'add_impression',
    version: 'v1',
    data: {
      eid
    }
  });
}
function logSignalEvent(event) {
  window._signalsDataLayer = window._signalsDataLayer || [];
  window._signalsDataLayer.push(event);
}
function logSearchTermImpression({
  domainEntity = {
    Fqdn: '',
    Extension: '',
    Price: ''
  },
  itc = '',
  eidPrefix = '',
  queryStringField = 'domainToCheck',
  currency = '',
  findKey = ''
} = {}) {
  const searchTerm = (0, _UrlHelper.getUrlQueryParam)(queryStringField);
  const searchTLD = (0, _UrlHelper.getTLD)(searchTerm);
  const data = {
    domain: domainEntity.Fqdn,
    resultTLD: domainEntity.Extension,
    searchTLD,
    searchTerm,
    item_tracking_code: itc,
    price: domainEntity.Price,
    currency,
    findKey
  };
  logEvent({
    eid: `${eidPrefix}.impression`,
    type: 'view',
    properties: data
  });
}